import React from 'react';

import { declOfNum } from '@helpers/formatHelper';

interface ICountDownTimerProps extends React.HTMLAttributes<HTMLSpanElement> {
  targetDate: Date;
  withSeconds?: boolean;
}

let timer: ReturnType<typeof setTimeout>;

const CountDownTimer: React.FC<ICountDownTimerProps> = ({
  targetDate,
  withSeconds = false,
  ...rest
}) => {
  const elRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    if (!elRef?.current) {
      return () => {};
    }

    const compute = () => {
      if (!elRef?.current) return;

      const now = new Date();
      const curTime = now.getTime();
      const diff = targetDate.getTime() - curTime;
      const days = diff > 86400000 ? Math.floor(diff / 86400000) : 0;
      const daysStr = days ? `${days} ${declOfNum(days, ['день', 'дня', 'дней'])}` : '';
      const timeStr = new Date(diff).toUTCString().substr(-12, withSeconds ? 8 : 5);
      elRef.current.textContent = [daysStr, timeStr].join(' ');
    };
    compute();
    timer = setInterval(compute, withSeconds ? 1000 : 60000);

    return () => clearInterval(timer);
  }, [elRef, withSeconds, targetDate]);

  return (
    <span ref={elRef} {...rest}>
      -
    </span>
  );
};

export default CountDownTimer;
